<div class="progress-text"
  [class.text-warning]="value < 1 && value >= 0.5"
  [class.text-danger]="value < 0.5"
>{{ value?.toFixed(2) || '-' }}</div>
<div
  class="progress progress-thin overflow-visible"
  role="progressbar"
  aria-valuemin="0"
  aria-valuemax="100"
>
  <div
    class="progress-bar overflow-visible"
    [style.width]="percentage + '%'"
    [class.progress-warning]="value < 1 && value >= 0.5"
    [class.progress-danger]="value < 0.5"
  >
  </div>
</div>
